module.exports = __webpack_public_path__ + "img/jhs-twin-twelve-v2.6ea70236.jpg";